import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Card, CardContent } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";

const SECTIONS = [
  {
    title: "1. Responsable del tratamiento",
    body: `I.E.P. San Isidro, con domicilio en Calle Independencia 765, Zaña, es responsable del tratamiento de los datos personales recogidos a través de este sitio web y de la plataforma educativa, de conformidad con la Ley N° 29733, Ley de Protección de Datos Personales, y su reglamento.`,
  },
  {
    title: "2. Datos que recopilamos",
    body: `Recopilamos datos de identificación y contacto de estudiantes, padres o apoderados y docentes (nombres, DNI, correo electrónico, teléfono, dirección), así como información académica (matrícula, calificaciones, asistencia) necesaria para la prestación del servicio educativo.`,
  },
  {
    title: "3. Finalidad del tratamiento",
    body: `Los datos se utilizan para gestionar la matrícula y el proceso educativo, emitir comunicaciones institucionales, atender consultas a través del formulario de contacto, y cumplir con las obligaciones legales ante el Ministerio de Educación.`,
  },
  {
    title: "4. Base legal",
    body: `El tratamiento se realiza con el consentimiento del titular de los datos (o de su apoderado, en el caso de menores de edad) y, cuando corresponda, en cumplimiento de obligaciones legales propias de una institución educativa.`,
  },
  {
    title: "5. Conservación de los datos",
    body: `Los datos personales se conservan durante el tiempo necesario para cumplir con la finalidad para la que fueron recabados y los plazos exigidos por la normativa educativa vigente.`,
  },
  {
    title: "6. Derechos ARCO",
    body: `El titular de los datos puede ejercer sus derechos de acceso, rectificación, cancelación y oposición (ARCO), así como revocar su consentimiento, escribiendo a informes@iepsanisidro.edu.pe.`,
  },
  {
    title: "7. Uso de cookies",
    body: `Nuestro sitio web utiliza cookies y tecnologías de almacenamiento local (localStorage) propias, necesarias para su correcto funcionamiento: mantener tu sesión iniciada, recordar tus preferencias (como el modo claro/oscuro) y guardar tu decisión sobre el aviso de cookies. No utilizamos cookies de publicidad ni de rastreo de terceros. Puedes eliminar o bloquear las cookies desde la configuración de tu navegador, aunque esto podría afectar el funcionamiento de algunas secciones de la plataforma.`,
  },
  {
    title: "8. Compartición con terceros",
    body: `No compartimos datos personales con terceros salvo obligación legal o cuando sea estrictamente necesario para la prestación del servicio (por ejemplo, plataformas de videoconferencia para clases en línea).`,
  },
  {
    title: "9. Seguridad de la información",
    body: `Aplicamos medidas técnicas y organizativas razonables para proteger los datos personales frente a accesos no autorizados, pérdida o alteración.`,
  },
  {
    title: "10. Cambios en esta política",
    body: `Esta política puede actualizarse para reflejar cambios normativos o en nuestros servicios. La fecha de la última actualización se indica al pie de esta página.`,
  },
];

export function PrivacyPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <div className="bg-[#fdf6f0]">
      <div className="mx-auto max-w-3xl px-4 pb-16 pt-24">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate("/")}
          className="mb-4 text-[#4a321c] hover:bg-[#4a321c]/10"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al inicio
        </Button>

        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#4a321c]/10 text-[#4a321c]">
            <ShieldCheck className="h-6 w-6" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold text-[#4a321c] sm:text-3xl">
              Política de Privacidad
            </h1>
            <p className="text-sm text-gray-500">I.E.P. San Isidro</p>
          </div>
        </div>

        <Card className="border border-[#e6d5ba] bg-white shadow-md">
          <CardContent className="space-y-6 p-6 md:p-8">
            <p className="text-sm leading-relaxed text-gray-600">
              En I.E.P. San Isidro valoramos la privacidad de nuestros
              estudiantes, padres de familia y docentes. Esta política
              describe cómo recopilamos, usamos y protegemos la información
              personal que nos proporcionan a través de nuestro sitio web y
              plataforma educativa.
            </p>

            {SECTIONS.map((section) => (
              <div key={section.title}>
                <h2 className="mb-2 text-base font-bold text-[#4a321c]">
                  {section.title}
                </h2>
                <p className="text-sm leading-relaxed text-gray-600">
                  {section.body}
                </p>
              </div>
            ))}

            <p className="pt-2 text-xs text-gray-400">
              Última actualización: agosto de 2026.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
